import axios from 'axios';
import config from '@/config';


export async function loadData(commit, mutationType, url) {
  try {
    const response = await axios.get(url);
    commit(mutationType, response.data);
  } catch (err) {
    console.log(err);
  }
}

export async function loadDataForSnapshot(commit, rootState, mutationType, urlPattern) {
  const snapshot = rootState.snapshot.currentSnapshot;
  if (snapshot) {
    const url = new URL(
      urlPattern(snapshot.id),
      config.ICOOL.BACKEND_HOST,
    ).href;
    await loadData(commit, mutationType, url);
  }
}
